module.exports = __webpack_public_path__ + "img/shipment_ready.7f028c35.png";